import React from "react";

// components
import PageHeader from "../../../PageHeader/PageHeader";
import PageInfo from "../../components/PageInfo";
import Quotes from "../../components/Quotes";
import Signup from "../../components/Signup.js";
import PageState from "../../components/PageState.js";

// styles
import styles from "./Index.module.css";

export default function Kristendomskursus() {
    return(
            <PageState
                pageName="Kristendomskursus"
                render={({ data, sections, sectionNames }) => {
    
                const { Sec1, Sec2, u4 } = data;

                const quote = `"At deltage i kurset var en fantastisk oplevelse! Jeg var ikke forventet at blive så engageret, men det gav mig virkelig en dybere forståelse af kristendommen uden at forudsætte forhåndsviden. De seks aftener var en rejse gennem tankevækkende oplæg, berigende gruppedrøftelser og en afsluttende fælles samtale. Kurset formåede at åbne mine øjne for vigtige aspekter af spiritualitet. 
                Jeg ser frem til at fortsætte i studiekredsen for en endnu dybere fordybelse!"`;

                const personInfo = {
                    name: "Lasse Olsen",
                };

                console.log(Sec2.text)

                return (
                    <div>

                        <PageHeader 
                            image={data.PageHeader.imageUrl} 
                            title={data.PageHeader.title} 
                            description={data.PageHeader.text} 
                            sections={sections} 
                            sectionNames={sectionNames} 
                        />

                        <section id={Sec1.secId} className={styles.sec1}>
                            <PageInfo 
                                image={""} 
                                title={Sec1.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec1.text }} />} 
                                version={"v2"} 
                            />
                        </section>

                        {/* <section id={u4.secId} className={styles.sec1}>
                            <PageInfo 
                                image={""} 
                                title={u4.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: u4.text }} />} 
                                version={"v2"} 
                            />
                        </section> */}

                        {/* <section id="Min Oplevelse"> 
                            <div className={styles.quoteWrapper}>
                                <Quotes 
                                    image={quoteImg} 
                                    title={"Min Oplevelse: Øjenåbner til Menneskelig Åndelighed"} 
                                    description={quote} 
                                    personInfo={personInfo} 
                                    version={"v2"} 
                                />
                            </div>
                        </section> */}

                        <section id={Sec2.secId} className={styles.sec1}>
                            <Signup 
                                title={Sec2.header} 
                                text= {Sec2.text} 
                                input={false} 
                                endpoint={"/Kristendomskursus"} 
                            />
                        </section>
                    </div>
                );
            }
        }/>
    );
}
